const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #1a5c2a', fontFamily:"'Georgia', serif", color:'#0a1f0e', lineHeight:'1.7', background:'#f2faf4' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2e8b47', paddingBottom:'8px', marginBottom:'24px', color:'#145a24' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#1e7a36', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2e8b47', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#e8f5ec', border:'2px solid #2e8b47', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#145a24', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2e8b47' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#1e7a36', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#edf7f0' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#145a24', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f4fbf6', border:'1px solid #b6dfc0', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#145a24', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#3a7a4a', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Details</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Post-Processing Workflow Timeline ───────────────────
function DiagramWorkflow() {
  const W = 980, H = 344;

  const steps = [
    { n:'1', title:'Print Complete',     sub:'Remove build plate',       col:'#546e7a', bg:'#f5f5f5', icon:'🖨️',
      time:'–',        detail:'Peel/twist plate from\nbuild platform. Wear\nnitrile gloves — uncured\nresin is toxic.' },
    { n:'2', title:'Drain & Drip',       sub:'Gravity drain excess',     col:'#1565c0', bg:'#e8f4ff', icon:'💧',
      time:'5–15 min',  detail:'Tilt plate above vat\nat 45°. Recover dripped\nresin; do not contaminate\nclean IPA bath.' },
    { n:'3', title:'Wash — Station 1',   sub:'Bulk IPA wash (dirty)',    col:'#1e7a36', bg:'#e8f5ec', icon:'🫙',
      time:'3–5 min',   detail:'Agitate in IPA bath.\nRemoves 80–90% resin.\nIPA darkens with use\n— replace when dark.' },
    { n:'4', title:'Wash — Station 2',   sub:'Clean IPA rinse',          col:'#2e7d32', bg:'#dff0e4', icon:'✨',
      time:'1–3 min',   detail:'Rinse in fresh IPA.\nFinal surface clean.\nUltrasonic agitation\naids fine detail.' },
    { n:'5', title:'Dry',                sub:'Remove all solvent',       col:'#e07b00', bg:'#fff8e1', icon:'💨',
      time:'5–15 min',  detail:'Air dry or compressed\nair. IPA must fully\nevaporate before\nUV curing begins.' },
    { n:'6', title:'UV Cure',            sub:'Post-cure photopolymer',   col:'#c0392b', bg:'#fff0f0', icon:'☀️',
      time:'2–10 min',  detail:'UV station at 405 nm.\nRotate part midway.\nTime varies by resin\ntype, colour & size.' },
    { n:'7', title:'Support Removal',    sub:'Clip, cut, sand supports', col:'#6a1b9a', bg:'#f5eeff', icon:'✂️',
      time:'5–60 min',  detail:'Flush cutters +\ntweezers. Grind / sand\nsupport stumps flush.\nOptional before cure.' },
    { n:'8', title:'Finishing',          sub:'Sand, prime, paint, coat', col:'#37474f', bg:'#f0f4f8', icon:'🎨',
      time:'variable',  detail:'Sand P120→P800+.\nApply filler primer.\nPaint with acrylics.\nSeal with clear coat.' },
  ];

  const stepW = (W - 20) / steps.length;

  // Layout
  const warnH   = 28;
  const warnY   = 14;
  const boxTopY = warnY + warnH + 14;   // 56
  const stepBoxH= 160;
  const arrowY  = boxTopY + stepBoxH / 2;
  const detailY = boxTopY + stepBoxH + 12;
  const detailH = 102;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Resin Print Post-Processing — Complete Workflow Sequence</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="wfArr" markerWidth="9" markerHeight="9" refX="7" refY="4.5" orient="auto">
            <polygon points="0 0, 8 4.5, 0 9" fill="#546e7a"/>
          </marker>
        </defs>

        {/* Warning banner */}
        <rect x={10} y={warnY} width={W - 20} height={warnH} rx={5} fill="#c0392b" opacity="0.09"/>
        <text x={W / 2} y={warnY + 18} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">
          ⚠  Steps 1–6 involve toxic uncured resin — wear nitrile gloves, work in ventilated area, UV-cure before sanding
        </text>

        {/* Backbone connector */}
        <line x1={20} y1={arrowY} x2={W - 20} y2={arrowY} stroke="#b6dfc0" strokeWidth="3"/>

        {steps.map(({ n, title, sub, col, bg, icon, time, detail }, i) => {
          const cx  = 10 + i * stepW + stepW / 2;
          const bx  = cx - stepW * 0.47;
          const bw2 = stepW * 0.94;

          const circleY = boxTopY + 22;
          const iconY   = boxTopY + 56;
          const titleY  = boxTopY + 88;
          const subY    = boxTopY + 103;
          const badgeY  = boxTopY + 116;
          const timeY   = boxTopY + 130;
          const divY    = boxTopY + 142;

          return (
            <g key={i}>
              {i < steps.length - 1 && (
                <line x1={bx + bw2 + 2} y1={arrowY}
                      x2={bx + stepW - (bw2 - stepW) / 2 - 4} y2={arrowY}
                      stroke="#546e7a" strokeWidth="2" markerEnd="url(#wfArr)"/>
              )}

              {/* Step box */}
              <rect x={bx} y={boxTopY} width={bw2} height={stepBoxH}
                    rx={7} fill={bg} stroke={col} strokeWidth="2"/>

              {/* Number circle */}
              <circle cx={cx} cy={circleY} r={14} fill={col}/>
              <text x={cx} y={circleY + 5} textAnchor="middle"
                    fontSize="13" fill="#fff" fontWeight="700">{n}</text>

              {/* Icon */}
              <text x={cx} y={iconY} textAnchor="middle" fontSize="24">{icon}</text>

              {/* Title */}
              <text x={cx} y={titleY} textAnchor="middle"
                    fontSize="11" fill={col} fontWeight="700">{title}</text>

              {/* Subtitle */}
              <text x={cx} y={subY} textAnchor="middle" fontSize="9" fill="#555">{sub}</text>

              {/* Divider */}
              <line x1={bx + 6} y1={divY} x2={bx + bw2 - 6} y2={divY}
                    stroke={col} strokeWidth="0.8" opacity="0.3"/>

              {/* Time badge */}
              <rect x={bx + 4} y={badgeY} width={bw2 - 8} height={18}
                    rx={4} fill={col} opacity="0.15"/>
              <text x={cx} y={timeY} textAnchor="middle"
                    fontSize="9.5" fill={col} fontWeight="700">{time}</text>

              {/* Detail box */}
              <rect x={bx} y={detailY} width={bw2} height={detailH}
                    rx={5} fill="#fff" stroke={col} strokeWidth="1.2"/>
              {detail.split('\n').map((line, li) => (
                <text key={li} x={cx} y={detailY + 18 + li * 18}
                      textAnchor="middle" fontSize="10" fill="#333" style={{lineHeight:1.4}}>{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>The standard resin post-processing sequence is: drain → two-stage wash → dry → UV cure → support removal → finishing. Support removal can optionally be performed before UV curing (easier to clip green/semi-cured supports), but the part must still be fully cured before any sanding or surface finishing. Never cure with IPA still present — the solvent inhibits surface cure and creates a tacky, oxygen-inhibited layer.</div>
    </div>
  );
}

// ── Diagram 2: Washing Station Cross-Section ──────────────────────
function DiagramWashStation() {
  const W = 980, H = 420;
  // Left label column 0–210, station centre 215–580, right panel 600–975
  const labelMaxX = 208;
  const sL = 218;

  const annots = [
    { dotX: sL + 90,  dotY: 56,  label: 'Lid / cover (prevents evaporation)' },
    { dotX: sL + 160, dotY: 100, label: 'Isopropyl alcohol (IPA) 91–99%' },
    { dotX: sL + 90,  dotY: 148, label: 'Print on build plate / basket' },
    { dotX: sL + 200, dotY: 195, label: 'Magnetic stirrer or agitator' },
    { dotX: sL + 80,  dotY: 240, label: 'Contamination layer (resin-heavy)' },
    { dotX: sL + 150, dotY: 290, label: 'Tank body (HDPE or glass)' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Washing Station — IPA Wash Tank Cross-Section &amp; Two-Stage Process</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="ipaGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#b3e0ff" stopOpacity="0.7"/>
            <stop offset="70%" stopColor="#64b5f6" stopOpacity="0.85"/>
            <stop offset="100%" stopColor="#1565c0" stopOpacity="0.6"/>
          </linearGradient>
          <linearGradient id="dirtyGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#64b5f6" stopOpacity="0.6"/>
            <stop offset="100%" stopColor="#5d4037" stopOpacity="0.5"/>
          </linearGradient>
          <linearGradient id="tankGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#b0bec5"/>
            <stop offset="100%" stopColor="#78909c"/>
          </linearGradient>
          <marker id="wsArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#546e7a"/>
          </marker>
        </defs>

        {/* Left annotations */}
        {annots.map(({ dotX, dotY, label }, i) => (
          <g key={i}>
            <text x={labelMaxX} y={dotY + 4} textAnchor="end" fontSize="10" fill="#333">{label}</text>
            <line x1={labelMaxX + 4} y1={dotY} x2={dotX - 5} y2={dotY}
                  stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            <circle cx={dotX} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* ── STATION 1: Dirty wash ── */}
        <text x={sL + 155} y={30} textAnchor="middle" fontSize="12" fill="#1565c0" fontWeight="700">Station 1 — Dirty Wash</text>

        {/* Tank outline */}
        <rect x={sL} y={40} width={310} height={14} rx={3} fill="url(#tankGrad)" stroke="#455a64" strokeWidth="1.5"/>
        {/* Lid */}
        <text x={sL + 155} y={52} textAnchor="middle" fontSize="9" fill="#fff">lid / cover</text>

        {/* Tank body */}
        <rect x={sL} y={54} width={12} height={260} fill="url(#tankGrad)" stroke="#455a64" strokeWidth="1.5"/>
        <rect x={sL + 298} y={54} width={12} height={260} fill="url(#tankGrad)" stroke="#455a64" strokeWidth="1.5"/>
        <rect x={sL} y={314} width={310} height={12} rx={2} fill="url(#tankGrad)" stroke="#455a64" strokeWidth="1.5"/>

        {/* IPA fluid */}
        <rect x={sL + 12} y={54} width={286} height={230} fill="url(#ipaGrad)"/>

        {/* Contamination gradient at bottom */}
        <rect x={sL + 12} y={234} width={286} height={50} fill="url(#dirtyGrad)" opacity="0.7"/>
        <text x={sL + 155} y={260} textAnchor="middle" fontSize="9" fill="#3e2723" fontWeight="700">resin / IPA contamination zone</text>

        {/* Agitation arrows */}
        {[60, 100, 140, 180, 220, 260].map((ax, ai) => (
          <g key={ai}>
            <path d={`M ${sL+ax},${220} Q ${sL+ax+15},${210} ${sL+ax+20},${220} Q ${sL+ax+5},${230} ${sL+ax},${220}`}
                  fill="none" stroke="#1565c0" strokeWidth="1.2" opacity="0.5"/>
          </g>
        ))}
        <text x={sL + 155} y={218} textAnchor="middle" fontSize="8" fill="#1565c0">agitation currents</text>

        {/* Print part in basket */}
        <rect x={sL + 100} y={120} width={150} height={12} rx={2} fill="#78909c" stroke="#546e7a" strokeWidth="1" strokeDasharray="3,2"/>
        {/* Part shape (simplified) */}
        <path d={`M ${sL+130},${132} L ${sL+130},${175} Q ${sL+175},${185} ${sL+220},${175} L ${sL+220},${132}`}
              fill="#c8944a" stroke="#906030" strokeWidth="1.2" opacity="0.8"/>
        {/* Resin dripping */}
        {[140, 160, 180, 200].map((dx, di) => (
          <ellipse key={di} cx={sL + dx} cy={185 + di * 6} rx={2} ry={3}
                   fill="#c8944a" opacity="0.6"/>
        ))}
        <text x={sL + 155} y={190} textAnchor="middle" fontSize="8" fill="#145a24">resin dissolving</text>

        {/* Magnetic stir bar */}
        <rect x={sL + 140} y={278} width={70} height={10} rx={5} fill="#c0392b" stroke="#8b0000" strokeWidth="1"/>
        <text x={sL + 155} y={296} textAnchor="middle" fontSize="8" fill="#c0392b">stir bar</text>

        {/* ── STATION 2: Clean rinse ── */}
        <rect x={sL + 322} y={40} width={168} height={286} rx={5}
              fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1.5"/>
        <text x={sL + 406} y={30} textAnchor="middle" fontSize="12" fill="#2e8b47" fontWeight="700">Station 2 — Clean Rinse</text>

        {/* Clean IPA */}
        <rect x={sL + 328} y={54} width={156} height={200} rx={3} fill="#b3e0ff" opacity="0.55"/>
        <text x={sL + 406} y={90} textAnchor="middle" fontSize="10" fill="#1565c0" fontWeight="700">Fresh / cleaner IPA</text>
        <text x={sL + 406} y={106} textAnchor="middle" fontSize="9" fill="#1565c0">or acetone for some resins</text>

        {/* Ultrasonic symbol */}
        {[332, 349, 366, 383, 400, 417].map((ux, ui) => (
          <path key={ui} d={`M ${sL + ux},${140} Q ${sL + ux + 5},${150} ${sL + ux},${160}`}
                fill="none" stroke="#2e8b47" strokeWidth="1.2" opacity="0.6"/>
        ))}
        <text x={sL + 406} y={178} textAnchor="middle" fontSize="8.5" fill="#2e8b47">ultrasonic waves</text>
        <text x={sL + 406} y={190} textAnchor="middle" fontSize="8.5" fill="#2e8b47">(optional — aids detail)</text>

        {/* Part in clean station */}
        <path d={`M ${sL+334},${210} L ${sL+334},${240} Q ${sL+406},${250} ${sL+478},${240} L ${sL+478},${210}`}
              fill="#a8d5b0" stroke="#2e8b47" strokeWidth="1.2" opacity="0.8"/>
        <text x={sL + 406} y={262} textAnchor="middle" fontSize="9" fill="#145a24" fontWeight="700">clean part</text>

        {/* Disposal note */}
        <rect x={sL + 330} y={286} width={156} height={36} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={sL + 406} y={302} textAnchor="middle" fontSize="9" fill="#c0392b" fontWeight="700">⚠ IPA disposal</text>
        <text x={sL + 406} y={315} textAnchor="middle" fontSize="8.5" fill="#922b21">Evaporate outdoors; UV-cure sludge</text>

        {/* ── Right info panel ── */}
        <rect x={716} y={16} width={256} height={390} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={844} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Wash Parameters</text>

        {[
          { heading:'IPA concentration',  body:'91–99% IPA recommended.\n70% isopropyl contains water\n— inhibits cure, causes cloudiness.' },
          { heading:'Wash time',          body:'Station 1: 3–5 min agitation.\nStation 2: 1–2 min rinse.\nOver-washing whitens/weakens part.' },
          { heading:'Alternatives to IPA',body:'Resin-specific wash solutions\n(Elegoo Wash, Anycubic Wash),\nmono-propylene glycol (less toxic).' },
          { heading:'Temperature effect', body:'Warm IPA (~30°C) cleans faster.\nCold IPA slower but less evaporation.\nNever heat near open flame.' },
          { heading:'IPA regeneration',   body:'Leave container in sunlight / UV —\nresin cures, settles as solid sludge.\nFilter and reuse partially spent IPA.' },
        ].map(({ heading, body }, i) => {
          const ry = 46 + i * 68;
          return (
            <g key={i}>
              <rect x={724} y={ry} width={244} height={62} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={732} y={ry + 17} fontSize="11" fill="#145a24" fontWeight="700">{heading}</text>
              {body.split('\n').map((line, li) => (
                <text key={li} x={732} y={ry + 31 + li * 14} fontSize="9.5" fill="#444">{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Two-stage washing is the industry standard: the first bath removes ~85–90% of uncured resin cheaply (IPA becomes contaminated quickly), and the second bath provides a clean final rinse. Ultrasonic agitation in the clean bath greatly improves washing of fine details and internal channels. IPA must fully evaporate before UV curing — residual solvent inhibits surface cure and leaves a sticky, oxygen-inhibited layer. Spent IPA can be regenerated by UV-curing the dissolved resin, which settles as solid sludge.</div>
    </div>
  );
}

// ── Diagram 3: UV Curing Station & Cure Depth ────────────────────
function DiagramUVCuring() {
  const W = 960, H = 400;

  // Left: curing station cross-section (0–430)
  // Right info panel (450–955)

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>UV Post-Curing Station — Anatomy, Cure Depth &amp; Resin Cure States</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <radialGradient id="uvGlow" cx="50%" cy="0%" r="80%">
            <stop offset="0%" stopColor="#7b1fa2" stopOpacity="0.5"/>
            <stop offset="60%" stopColor="#4a148c" stopOpacity="0.15"/>
            <stop offset="100%" stopColor="#4a148c" stopOpacity="0"/>
          </radialGradient>
          <linearGradient id="mirrorGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#e0e0e0"/>
            <stop offset="100%" stopColor="#bdbdbd"/>
          </linearGradient>
          <linearGradient id="cureGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#7b1fa2" stopOpacity="0.8"/>
            <stop offset="40%" stopColor="#1565c0" stopOpacity="0.4"/>
            <stop offset="100%" stopColor="#1565c0" stopOpacity="0.05"/>
          </linearGradient>
          <marker id="uvArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#7b1fa2"/>
          </marker>
        </defs>

        {/* ── UV station body ── */}
        {/* Chamber walls */}
        <rect x={30} y={30} width={390} height={320} rx={8}
              fill="#f3e5f5" stroke="#7b1fa2" strokeWidth="2"/>
        <text x={225} y={22} textAnchor="middle" fontSize="10" fill="#7b1fa2">UV curing chamber</text>

        {/* Reflective interior walls */}
        <rect x={38} y={38} width={374} height={304} rx={5}
              fill="url(#mirrorGrad)" stroke="#bdbdbd" strokeWidth="1" opacity="0.4"/>

        {/* UV LED strips — top */}
        {[60, 120, 180, 240, 300, 360].map((x, i) => (
          <g key={i}>
            <rect x={x} y={42} width={24} height={10} rx={2} fill="#7b1fa2" opacity="0.8"/>
            {/* UV beam cone */}
            <path d={`M ${x + 12},${52} L ${x - 20},${180} L ${x + 44},${180}`}
                  fill="#7b1fa2" opacity="0.05"/>
          </g>
        ))}
        <text x={225} y={62} textAnchor="middle" fontSize="9" fill="#7b1fa2" fontWeight="700">UV LED array (405 nm)</text>

        {/* UV glow effect */}
        <rect x={38} y={38} width={374} height={304} rx={5} fill="url(#uvGlow)"/>

        {/* UV rays from top */}
        {[80, 140, 200, 260, 320, 380].map((x, i) => (
          <line key={i} x1={x} y1={52} x2={x + (i%2===0?-20:20)} y2={200}
                stroke="#ce93d8" strokeWidth="1" opacity="0.4" strokeDasharray="3,4"/>
        ))}

        {/* Turntable platform */}
        <ellipse cx={225} cy={260} rx={100} ry={18} fill="#78909c" stroke="#546e7a" strokeWidth="1.5" opacity="0.85"/>
        <text x={225} y={264} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">rotating turntable</text>
        {/* Rotation arrows */}
        <path d="M 155,255 A 70 12 0 0 1 295,255" fill="none" stroke="#546e7a" strokeWidth="1.5" strokeDasharray="4,3" markerEnd="url(#uvArr)"/>
        <text x={225} y={286} textAnchor="middle" fontSize="8" fill="#546e7a">360° even exposure</text>

        {/* Part on turntable */}
        <path d="M 185,244 L 185,218 Q 225,208 265,218 L 265,244"
              fill="#c8944a" stroke="#906030" strokeWidth="1.2" opacity="0.9"/>
        <text x={225} y={230} textAnchor="middle" fontSize="8.5" fill="#fff">print</text>

        {/* Cure depth diagram inside part */}
        <rect x={190} y={218} width={70} height={26} rx={2} fill="url(#cureGrad)" opacity="0.6"/>
        <text x={225} y={210} textAnchor="middle" fontSize="7.5" fill="#7b1fa2">UV penetration depth</text>

        {/* Side UV strips */}
        {[80, 140, 200, 260, 320].map((y, i) => (
          <g key={i}>
            <rect x={38} y={y} width={10} height={18} rx={2} fill="#7b1fa2" opacity="0.6"/>
            <rect x={404} y={y} width={10} height={18} rx={2} fill="#7b1fa2" opacity="0.6"/>
          </g>
        ))}
        <text x={46} y={162} textAnchor="middle" fontSize="7.5" fill="#7b1fa2"
              transform="rotate(-90 46 162)">side LEDs</text>
        <text x={412} y={162} textAnchor="middle" fontSize="7.5" fill="#7b1fa2"
              transform="rotate(-90 412 162)">side LEDs</text>

        {/* Timer display */}
        <rect x={160} y={304} width={130} height={38} rx={4} fill="#1a1a2e" stroke="#7b1fa2" strokeWidth="1.5"/>
        <text x={225} y={320} textAnchor="middle" fontSize="10" fill="#ce93d8" fontFamily="'Courier New',monospace">02:30</text>
        <text x={225} y={335} textAnchor="middle" fontSize="8" fill="#7b1fa2">cure timer</text>

        {/* ── Right panel: cure states ── */}
        <rect x={446} y={16} width={508} height={H - 28} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={700} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Cure States &amp; UV Parameters</text>

        {/* Three cure state panels */}
        {[
          { state:'Under-cured',   col:'#e07b00', bg:'#fff8e1',
            signs:['Tacky / sticky surface','Easily scratched or bent','White powdery residue','Parts warp after days'],
            fix:'Extend cure time;\ncheck UV wavelength (405 nm);\nensure even rotation.' },
          { state:'Optimal cure',  col:'#1e7a36', bg:'#e8f5ec',
            signs:['Smooth, matte or satin surface','Hard — cannot indent with nail','Consistent colour throughout','Stable dimensions over time'],
            fix:'Typical: 2–5 min per side;\nrotate halfway through;\nmatch resin manufacturer spec.' },
          { state:'Over-cured',    col:'#c0392b', bg:'#fff0f0',
            signs:['Brittle — snaps rather than flexes','Yellow / brown discolouration','Micro-cracks on surface','Fine details may shatter'],
            fix:'Reduce time or power;\nuse timer precisely;\ndark resins cure faster.' },
        ].map(({ state, col, bg, signs, fix }, i) => {
          const ry = 46 + i * 108;
          return (
            <g key={i}>
              <rect x={454} y={ry} width={492} height={102} rx={4} fill={bg} stroke={col} strokeWidth="1.2"/>
              <text x={462} y={ry + 18} fontSize="12" fill={col} fontWeight="700">{state}</text>
              {/* Signs */}
              {signs.map((s, si) => (
                <text key={si} x={462} y={ry + 34 + si * 14} fontSize="9.5" fill="#333">
                  {i===1?'✔':'✗'} {s}
                </text>
              ))}
              {/* Fix hint */}
              {fix.split('\n').map((line, li) => (
                <text key={li} x={740} y={ry + 34 + li * 14} fontSize="9.5" fill={col} fontWeight={li===0?'700':'400'}>{line}</text>
              ))}
            </g>
          );
        })}

        {/* UV parameters table */}
        <rect x={454} y={376} width={492} height={14} rx={3} fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
        <text x={700} y={387} textAnchor="middle" fontSize="9.5" fill="#145a24" fontWeight="700">
          Standard: 405 nm wavelength · 10–50 W power · 2–10 min total · rotate 90° every pass
        </text>
      </svg>
      <div style={S.dCaption}>UV post-curing completes the photopolymerisation initiated during printing. The rotating turntable ensures all surfaces receive even UV exposure — without rotation, shadowed areas remain under-cured and tacky. Standard post-cure stations use 405 nm LED arrays (matching the photoinitiator absorption peak of most MSLA/DLP resins). Curing time varies significantly by resin type, colour (darker resins cure faster), and part geometry — always consult the resin manufacturer's recommended exposure schedule.</div>
    </div>
  );
}

// ── Diagram 4: Support Removal Techniques ─────────────────────────
function DiagramSupportRemoval() {
  const W = 960, H = 440;
  const panelW = (W - 20) / 3;

  const techniques = [
    {
      title: 'Manual Hand Tools',
      col: '#1e7a36', bg: '#f0fff4',
      tools: [
        { name:'Flush cutter (sprue nipper)', use:'Close-cut support stems at base' },
        { name:'Dental pick / scalpel',        use:'Reach tight areas and fine features' },
        { name:'Tweezers (fine-tip)',           use:'Grasp and peel thin support webs' },
        { name:'Needle-nose pliers',           use:'Twist and snap larger supports' },
      ],
      tips: ['Remove before full cure for easier clipping','Work toward part to avoid breaking features','Dampen tool tip to reduce static','Wear gloves — uncured resin on supports'],
    },
    {
      title: 'Mechanical / Power',
      col: '#1565c0', bg: '#f0f4ff',
      tools: [
        { name:'Rotary tool (Dremel + burr)', use:'Grind support stumps flush' },
        { name:'Mini drill press',            use:'Consistent depth removal' },
        { name:'Ultrasonic cleaner probe',    use:'Vibrate off thin web supports' },
        { name:'Sand / abrasive paper',       use:'Level stump scars (P120→P400)' },
      ],
      tips: ['Secure part firmly — avoid slip injuries','Use low speed to prevent melting','Water-cool if friction heats part','Eye protection — resin fragments fly'],
    },
    {
      title: 'Chemical / Dissolution',
      col: '#c0392b', bg: '#fff0f0',
      tools: [
        { name:'IPA soak (extended)',          use:'Soften support-part interface' },
        { name:'Acetone (for ABS-like resin)', use:'Dissolve certain support materials' },
        { name:'HIPS dissolver (d-Limonene)',  use:'Dissolves HIPS supports in dual-resin' },
        { name:'NaOH solution (1–5%)',         use:'Breaks down PVA-type supports' },
      ],
      tips: ['Test on scrap — solvent may attack part','Use fume hood or good ventilation','Neutralise alkaline solutions before drain','Never mix solvents — toxic reactions'],
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Support Removal Techniques — Hand Tools, Mechanical &amp; Chemical Methods</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {techniques.map(({ title, col, bg, tools, tips }, ti) => {
          const px = 10 + ti * panelW;
          const pw = panelW - 8;
          const cx = px + pw / 2;

          return (
            <g key={ti}>
              <rect x={px} y={8} width={pw} height={H - 16} rx={5} fill={bg} stroke={col} strokeWidth="1.5"/>

              {/* Title */}
              <text x={cx} y={28} textAnchor="middle" fontSize="12" fill={col} fontWeight="700">{title}</text>

              {/* Tool illustration — simplified SVG per type */}
              {ti === 0 && (
                // Flush cutter silhouette
                <g>
                  <rect x={cx - 40} y={38} width={80} height={44} rx={4} fill={col} opacity="0.12" stroke={col} strokeWidth="1"/>
                  <line x1={cx - 20} y1={50} x2={cx + 20} y2={70} stroke={col} strokeWidth="3" strokeLinecap="round"/>
                  <line x1={cx - 20} y1={70} x2={cx + 20} y2={50} stroke={col} strokeWidth="3" strokeLinecap="round"/>
                  <circle cx={cx} cy={60} r={6} fill={col} opacity="0.6"/>
                  <text x={cx} y={94} textAnchor="middle" fontSize="8" fill={col}>flush cutters (nipper)</text>
                </g>
              )}
              {ti === 1 && (
                // Rotary tool
                <g>
                  <rect x={cx - 40} y={38} width={80} height={44} rx={4} fill={col} opacity="0.12" stroke={col} strokeWidth="1"/>
                  <rect x={cx - 8} y={42} width={16} height={34} rx={4} fill={col} opacity="0.5"/>
                  <circle cx={cx} cy={80} r={8} fill={col} opacity="0.7"/>
                  {[-20,-12,-4,4,12,20].map((dx, ri) => (
                    <line key={ri} x1={cx + dx} y1={78} x2={cx + dx + 4} y2={84}
                          stroke="#fff" strokeWidth="1.5" opacity="0.7"/>
                  ))}
                  <text x={cx} y={94} textAnchor="middle" fontSize="8" fill={col}>rotary tool + burr</text>
                </g>
              )}
              {ti === 2 && (
                // Chemical beaker
                <g>
                  <rect x={cx - 40} y={38} width={80} height={44} rx={4} fill={col} opacity="0.12" stroke={col} strokeWidth="1"/>
                  <path d={`M ${cx-20},42 L ${cx-22},78 L ${cx+22},78 L ${cx+20},42 Z`}
                        fill={col} opacity="0.2" stroke={col} strokeWidth="1.2"/>
                  <rect x={cx - 22} y={65} width={44} height={14} rx={0} fill={col} opacity="0.4"/>
                  {[-10,-5,0,5,10].map((dx, bi) => (
                    <circle key={bi} cx={cx + dx} cy={60} r={2} fill={col} opacity="0.6"/>
                  ))}
                  <text x={cx} y={94} textAnchor="middle" fontSize="8" fill={col}>chemical / solvent bath</text>
                </g>
              )}

              {/* Tools list */}
              <rect x={px + 6} y={102} width={pw - 12} height={tools.length * 36 + 10} rx={3}
                    fill="#fff" stroke={col} strokeWidth="1" opacity="0.9"/>
              {tools.map(({ name, use }, ii) => {
                const ty2 = 114 + ii * 36;
                return (
                  <g key={ii}>
                    <text x={px + 12} y={ty2} fontSize="9.5" fill={col} fontWeight="700">{name}</text>
                    <text x={px + 12} y={ty2 + 14} fontSize="9" fill="#555">{use}</text>
                    {ii < tools.length - 1 && (
                      <line x1={px + 10} y1={ty2 + 20} x2={px + pw - 10} y2={ty2 + 20}
                            stroke="#b6dfc0" strokeWidth="0.5"/>
                    )}
                  </g>
                );
              })}

              {/* Tips */}
              {(()=>{
                const tipY = 102 + tools.length * 36 + 18;
                return (
                  <g>
                    <rect x={px + 6} y={tipY} width={pw - 12} height={tips.length * 18 + 16} rx={3}
                          fill={ti===2?'#FEF0F0':'#e8f5ec'} stroke={ti===2?'#c0392b':'#2e8b47'} strokeWidth="1"/>
                    <text x={px + 12} y={tipY + 14} fontSize="9.5" fill={ti===2?'#c0392b':'#1e7a36'} fontWeight="700">Tips &amp; Safety:</text>
                    {tips.map((tip, tii) => (
                      <text key={tii} x={px + 12} y={tipY + 28 + tii * 18} fontSize="8.5" fill="#333">• {tip}</text>
                    ))}
                  </g>
                );
              })()}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Support removal strategy depends on support density, part geometry, and resin type. The most critical decision is timing: removing supports before full UV cure (in the "green state") is mechanically easier — supports are more flexible and snap cleanly — but the part is still coated in toxic uncured resin requiring full PPE. Removing after full cure gives a safer working environment but requires more force. Chitubox / Lychee slicer support settings (touch point size 0.4–0.8 mm, density 50–80%) heavily influence removal difficulty.</div>
    </div>
  );
}

// ── Diagram 5: Surface Finishing Methods Comparison ──────────────
function DiagramSurfaceFinishing() {
  const W = 960, H = 440;

  const methods = [
    { name:'Wet sanding',        col:'#1565c0',
      steps:'P120 → P220 → P400\n→ P800 → P1500 → P2000',
      attrs:{ smoothness:9, speed:3, cost:9, detail:7, durability:6 },
      notes:'Best for smooth curves;\nuse water as lubricant;\nwrap paper around dowel for curved areas' },
    { name:'Dry sanding',        col:'#1e7a36',
      steps:'P120 → P220 → P400\n→ P600+',
      attrs:{ smoothness:7, speed:5, cost:9, detail:6, durability:6 },
      notes:'Faster but dust risk;\nuse respirator (P100);\nclogged paper — use tack cloth' },
    { name:'Resin coating',      col:'#c0392b',
      steps:'Brush clear resin over\nsanded part → UV cure',
      attrs:{ smoothness:10, speed:8, cost:5, detail:5, durability:9 },
      notes:'XTC-3D or clear resin;\nlevels layer lines;\ncure under UV immediately' },
    { name:'Spray primer',       col:'#e07b00',
      steps:'Fine primer coat →\nsand P400 → repeat',
      attrs:{ smoothness:8, speed:7, cost:6, detail:8, durability:7 },
      notes:'Rattlecan filler primer;\nfills micro-scratches;\n2–3 coats with sanding between' },
    { name:'Airbrushing / paint',col:'#6a1b9a',
      steps:'Prime → base coat\n→ detail layers → clear',
      attrs:{ smoothness:8, speed:5, cost:5, detail:10, durability:7 },
      notes:'Acrylic paints adhere well;\nprimer is essential;\nprotect with matte/satin varnish' },
    { name:'Vapour smoothing',   col:'#546e7a',
      steps:'IPA vapour bath\n(for castable / flexible resin)',
      attrs:{ smoothness:9, speed:9, cost:6, detail:6, durability:7 },
      notes:'Risk of over-smoothing;\ndetail loss possible;\nuse specialised units (Polymaker)' },
  ];

  const attrs = ['smoothness','speed','cost','detail','durability'];
  const attrLabels = ['Smoothness','Speed','Cost','Detail presv.','Durability'];

  const colW = (W - 220) / methods.length;
  const barMaxW = colW - 16;
  const headerH = 110;
  const attrRowH = 36;
  const notesH = 86;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Surface Finishing Methods — Attribute Comparison (score 1–10)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Left attribute labels */}
        <rect x={0} y={0} width={218} height={H} fill="#f4fbf6" stroke="#b6dfc0" strokeWidth="0.5"/>
        <text x={109} y={20} textAnchor="middle" fontSize="11" fill="#145a24" fontWeight="700">Attribute</text>

        {attrs.map((a, ai) => (
          <g key={ai}>
            <text x={8} y={headerH + ai * attrRowH + 16} fontSize="10.5" fill="#145a24" fontWeight="700">{attrLabels[ai]}</text>
            <text x={8} y={headerH + ai * attrRowH + 29} fontSize="8.5" fill="#546e7a">(1=low, 10=high)</text>
            <line x1={0} y1={headerH + (ai+1)*attrRowH} x2={218} y2={headerH + (ai+1)*attrRowH}
                  stroke="#b6dfc0" strokeWidth="0.5"/>
          </g>
        ))}
        <text x={8} y={headerH + attrs.length * attrRowH + 16} fontSize="10.5" fill="#145a24" fontWeight="700">Notes</text>

        {/* Method columns */}
        {methods.map(({ name, col, steps, attrs: avals, notes }, mi) => {
          const cx2 = 220 + mi * colW + colW / 2;
          const bx = 220 + mi * colW + 8;

          return (
            <g key={mi}>
              {/* Header */}
              <rect x={220 + mi * colW} y={0} width={colW} height={headerH}
                    fill={mi%2===0?'#f4fbf6':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
              <rect x={220 + mi * colW + 2} y={4} width={colW - 4} height={26} rx={3} fill={col} opacity="0.85"/>
              <text x={cx2} y={21} textAnchor="middle" fontSize="9.5" fill="#fff" fontWeight="700">{name}</text>
              {steps.split('\n').map((line, li) => (
                <text key={li} x={cx2} y={38 + li * 14} textAnchor="middle" fontSize="8.5" fill="#333">{line}</text>
              ))}

              {/* Attribute bars */}
              {attrs.map((a, ai) => {
                const score = avals[a];
                const ry = headerH + ai * attrRowH;
                const barW2 = (score / 10) * barMaxW;
                const barCol = score >= 8 ? '#1e7a36' : score >= 5 ? '#e07b00' : '#c0392b';
                return (
                  <g key={ai}>
                    <rect x={220 + mi * colW} y={ry} width={colW} height={attrRowH}
                          fill={mi%2===0?'#f4fbf6':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
                    {/* Track */}
                    <rect x={bx} y={ry + 8} width={barMaxW} height={18} rx={3}
                          fill="#e8f5ec" stroke="#b6dfc0" strokeWidth="0.5"/>
                    {/* Bar */}
                    <rect x={bx} y={ry + 8} width={barW2} height={18} rx={3}
                          fill={barCol} opacity="0.82"/>
                    {/* Score */}
                    <text x={bx + barMaxW - 2} y={ry + 21} textAnchor="end"
                          fontSize="9" fill="#fff" fontWeight="700">{score}</text>
                  </g>
                );
              })}

              {/* Notes */}
              <rect x={220 + mi * colW} y={headerH + attrs.length * attrRowH}
                    width={colW} height={notesH} fill={mi%2===0?'#f4fbf6':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
              {notes.split('\n').map((line, li) => (
                <text key={li} x={cx2} y={headerH + attrs.length * attrRowH + 16 + li * 20}
                      textAnchor="middle" fontSize="8" fill="#444"
                      style={{overflow:'hidden'}}>{line.length > 30 ? line.slice(0,28)+'…' : line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Surface finishing is the most time-intensive post-processing stage. Wet sanding with progressive grits (P120→P2000) produces the best surface quality but requires patience — each grit step must remove all scratches from the previous. Resin coating (brushing clear resin and UV-curing) efficiently fills layer lines and produces a glass-smooth finish in one or two coats but can obscure fine detail. Primer is essential before painting — bare resin is often too smooth for paint adhesion without a mechanical tooth.</div>
    </div>
  );
}

// ── Diagram 6: Safety & Chemical Hazard Matrix ────────────────────
function DiagramSafetyMatrix() {
  const W = 960, H = 380;

  const chemicals = [
    'Uncured liquid resin',
    'IPA (isopropyl alcohol)',
    'Acetone',
    'UV-cured resin dust',
    'Resin wash solution',
    'Aerosol primer / paint',
    'Clear coat / varnish',
  ];

  const hazards = [
    { label:'Skin\nirritant',    short:'Skin' },
    { label:'Respiratory\nhazard', short:'Resp.' },
    { label:'Eye\nhazard',      short:'Eye' },
    { label:'Fire /\nflammable', short:'Fire' },
    { label:'Sensitiser\n(allergy)', short:'Sens.' },
    { label:'Environmental\nhazard', short:'Env.' },
  ];

  // 0=none, 1=low, 2=medium, 3=high
  const matrix = [
    [3, 2, 3, 0, 3, 2],  // Uncured resin
    [1, 2, 1, 3, 1, 1],  // IPA
    [2, 3, 2, 3, 1, 1],  // Acetone
    [2, 3, 1, 0, 2, 1],  // Cured resin dust
    [2, 2, 2, 2, 1, 1],  // Wash solution
    [1, 3, 1, 3, 1, 2],  // Aerosol primer
    [1, 2, 1, 2, 1, 1],  // Clear coat
  ];

  const ppe = [
    'Nitrile gloves + face shield + apron + organic vapour respirator',
    'Nitrile gloves + safety glasses; ventilation',
    'Nitrile gloves + safety glasses; NO ignition sources; ventilation',
    'P100 / FFP3 respirator + safety glasses (carcinogen risk)',
    'Nitrile gloves + safety glasses; ventilation',
    'N95 / P1 respirator + safety glasses; outdoor or LEV',
    'N95 respirator + safety glasses; ventilation',
  ];

  const ratingColors = ['#f4fbf6','#fff3cd','#ffe0b2','#ffcdd2'];
  const ratingLabels = ['None','Low','Medium','High'];
  const ratingTextCol= ['#546e7a','#8b5c00','#bf4500','#c0392b'];

  const nameColW = 190;
  const ppeColW  = 220;
  const cellW = (W - nameColW - ppeColW) / hazards.length;
  const headerH = 56;
  const rowH = (H - headerH - 30) / chemicals.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Safety &amp; Chemical Hazard Matrix — Post-Processing Chemicals</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header */}
        <rect x={0} y={0} width={W} height={headerH} fill="#1e7a36"/>
        <text x={nameColW/2} y={headerH/2 + 5} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Chemical</text>
        {hazards.map(({ label }, hi) => {
          const hx = nameColW + hi * cellW + cellW / 2;
          return (
            <g key={hi}>
              {label.split('\n').map((line, li) => (
                <text key={li} x={hx} y={16 + li * 16} textAnchor="middle" fontSize="9.5" fill="#fff" fontWeight="700">{line}</text>
              ))}
            </g>
          );
        })}
        <text x={nameColW + hazards.length * cellW + ppeColW / 2} y={headerH/2 + 5}
              textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Minimum PPE</text>

        {/* Data rows */}
        {chemicals.map((chem, ci) => {
          const ry = headerH + ci * rowH;
          return (
            <g key={ci}>
              <rect x={0} y={ry} width={W} height={rowH}
                    fill={ci%2===0?'#f4fbf6':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
              <text x={8} y={ry + rowH/2 + 4} fontSize="10" fill="#145a24" fontWeight="600">{chem}</text>
              {matrix[ci].map((rating, hi) => {
                const cx2 = nameColW + hi * cellW + cellW / 2;
                return (
                  <g key={hi}>
                    <rect x={nameColW + hi * cellW + 2} y={ry + 3} width={cellW - 4} height={rowH - 6}
                          rx={3} fill={ratingColors[rating]} stroke="#b6dfc0" strokeWidth="0.8"/>
                    <text x={cx2} y={ry + rowH/2 + 4} textAnchor="middle" fontSize="9.5"
                          fill={ratingTextCol[rating]} fontWeight="700">{ratingLabels[rating]}</text>
                  </g>
                );
              })}
              {/* PPE */}
              <text x={nameColW + hazards.length * cellW + 6} y={ry + rowH/2 + 4}
                    fontSize="7.8" fill="#333">{ppe[ci]}</text>
            </g>
          );
        })}

        {/* Legend */}
        {ratingLabels.map((rl, ri) => (
          <g key={ri}>
            <rect x={nameColW + ri * 110} y={headerH + chemicals.length * rowH + 6}
                  width={50} height={16} rx={3} fill={ratingColors[ri]} stroke="#b6dfc0" strokeWidth="0.8"/>
            <text x={nameColW + ri * 110 + 54} y={headerH + chemicals.length * rowH + 18}
                  fontSize="10" fill={ratingTextCol[ri]} fontWeight="700">{rl}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Uncured liquid resin is classified as a skin sensitiser (may cause lifelong allergic contact dermatitis after repeated exposure) and is harmful if swallowed or inhaled — treat all uncured resin as toxic waste. UV-cured resin dust from sanding is a respiratory hazard and potentially carcinogenic; always wear a P100/FFP3 respirator when dry-sanding. IPA and acetone are fire hazards — no open flames in the workspace. Store all chemicals in sealed containers, away from UV light, and dispose per local chemical waste regulations.</div>
    </div>
  );
}

// ── Diagram 7: Resin Type Properties & Post-Processing Needs ───────
function DiagramResinTypes() {
  const W = 960, H = 460;

  const resins = [
    { name:'Standard resin',      col:'#1565c0', washTime:4,  cureTime:5,  supportEase:7, surfaceQ:6, strength:4,  flex:3,  cost:9,
      notes:'Most common; brittle;\ngood for display models' },
    { name:'ABS-like resin',      col:'#1e7a36', washTime:4,  cureTime:5,  supportEase:6, surfaceQ:6, strength:7,  flex:5,  cost:7,
      notes:'Tougher, less brittle;\nfunctional parts' },
    { name:'Flexible / TPU resin',col:'#c0392b', washTime:5,  cureTime:7,  supportEase:5, surfaceQ:5, strength:4,  flex:10, cost:6,
      notes:'Rubbery; longer wash;\nvapour smoothing works' },
    { name:'High-temp resin',     col:'#e07b00', washTime:3,  cureTime:8,  supportEase:4, surfaceQ:7, strength:8,  flex:2,  cost:4,
      notes:'HDT 180–300°C;\nlong UV cure needed;\ncasting patterns' },
    { name:'Castable (wax) resin',col:'#6a1b9a', washTime:3,  cureTime:9,  supportEase:8, surfaceQ:9, strength:3,  flex:2,  cost:4,
      notes:'Burns out cleanly;\nno sanding needed;\njewellery casting' },
    { name:'Water-washable resin',col:'#00796b', washTime:8,  cureTime:5,  supportEase:7, surfaceQ:5, strength:4,  flex:3,  cost:7,
      notes:'No IPA required;\nwater wash but softer;\nhigher shrinkage' },
    { name:'Dental / bio resin',  col:'#37474f', washTime:5,  cureTime:8,  supportEase:6, surfaceQ:9, strength:7,  flex:4,  cost:2,
      notes:'ISO 10993 biocompatible;\nstrict cure protocol;\nclinical use' },
  ];

  const attrs = [
    { key:'washTime',    label:'Wash difficulty', note:'higher = harder' },
    { key:'cureTime',    label:'Cure time need',  note:'higher = longer' },
    { key:'supportEase', label:'Support ease',    note:'higher = easier' },
    { key:'surfaceQ',    label:'Surface quality', note:'higher = better' },
    { key:'strength',    label:'Tensile strength',note:'higher = stronger' },
    { key:'flex',        label:'Flexibility',     note:'higher = more flex' },
    { key:'cost',        label:'Cost efficiency', note:'higher = cheaper' },
  ];

  const colW = (W - 200) / resins.length;
  const headerH = 80;
  const notesAreaH = 58;
  const attrH = (H - headerH - notesAreaH) / attrs.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Resin Types — Post-Processing Requirements &amp; Property Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header row */}
        <rect x={0} y={0} width={W} height={headerH} fill="#1e7a36"/>
        <text x={100} y={headerH/2 + 5} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Attribute</text>

        {resins.map(({ name, col }, ri) => {
          const hx = 200 + ri * colW + colW / 2;
          return (
            <g key={ri}>
              <rect x={200 + ri * colW + 2} y={4} width={colW - 4} height={headerH - 8} rx={3} fill={col} opacity="0.3"/>
              <text x={hx} y={headerH/2 - 6} textAnchor="middle" fontSize="9"
                    fill="#fff" fontWeight="700"
                    transform={`rotate(-20 ${hx} ${headerH/2 - 6})`}>{name.split(' ')[0]}</text>
              <text x={hx} y={headerH/2 + 8} textAnchor="middle" fontSize="8" fill="#d4f0da">
                {name.split(' ').slice(1).join(' ')}
              </text>
            </g>
          );
        })}

        {/* Attribute rows */}
        {attrs.map(({ key, label, note }, ai) => {
          const ry = headerH + ai * attrH;
          return (
            <g key={ai}>
              <rect x={0} y={ry} width={W} height={attrH}
                    fill={ai%2===0?'#f4fbf6':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
              <text x={8} y={ry + attrH/2} fontSize="10.5" fill="#145a24" fontWeight="700">{label}</text>
              <text x={8} y={ry + attrH/2 + 13} fontSize="8.5" fill="#546e7a">{note}</text>

              {resins.map(({ col }, ri) => {
                const score = resins[ri][key];
                const cx2 = 200 + ri * colW + colW / 2;
                const barH2 = Math.max(4, (score / 10) * (attrH - 8));
                const barCol = key === 'washTime' || key === 'cureTime'
                  ? (score >= 7 ? '#c0392b' : score >= 5 ? '#e07b00' : '#1e7a36')
                  : (score >= 7 ? '#1e7a36' : score >= 4 ? '#e07b00' : '#c0392b');
                return (
                  <g key={ri}>
                    {/* Cell background */}
                    <rect x={200 + ri * colW + 2} y={ry + 2} width={colW - 4} height={attrH - 4}
                          fill={`${col}10`} rx={2}/>
                    {/* Bar from bottom */}
                    <rect x={200 + ri * colW + colW/2 - 10} y={ry + attrH - 4 - barH2}
                          width={20} height={barH2} rx={2} fill={barCol} opacity="0.8"/>
                    {/* Score */}
                    <text x={cx2} y={ry + attrH - 6} textAnchor="middle" fontSize="8" fill="#fff" fontWeight="700">{score}</text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* Notes row */}
        {resins.map(({ notes, col }, ri) => {
          const ny = headerH + attrs.length * attrH + 4;
          const cx2 = 200 + ri * colW + colW / 2;
          return (
            <g key={ri}>
              <rect x={200 + ri * colW + 1} y={ny} width={colW - 2} height={notesAreaH - 8}
                    rx={2} fill={`${col}12`}/>
              {notes.split('\n').map((line, li) => (
                <text key={li} x={cx2} y={ny + 12 + li * 14} textAnchor="middle"
                      fontSize="8" fill={col}>{line}</text>
              ))}
            </g>
          );
        })}
        <text x={100} y={headerH + attrs.length * attrH + 16} fontSize="10" fill="#546e7a" fontWeight="700">Notes:</text>
      </svg>
      <div style={S.dCaption}>Resin selection significantly impacts post-processing requirements. Water-washable resins eliminate IPA but require more aggressive agitation and tend to produce softer, less dimensionally stable parts. Flexible resins require longer IPA wash times (resin clings to the surface) and extended UV curing; they respond well to vapour smoothing. High-temperature and castable resins need long post-cure schedules (often 30–60 min under high-power UV) to achieve their rated mechanical properties. Always refer to the resin manufacturer's specific wash and cure protocol.</div>
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────
export default function ResinPostProcessing() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Resin 3D Print Post-Processing — Industrial Engineering</h1>
      <p style={S.p}>
        Resin 3D printing (MSLA, DLP, SLA) produces parts with excellent surface detail and resolution, but every print requires a mandatory post-processing sequence before the part is safe to handle or functionally useful. Unlike FDM printing, resin parts emerge from the printer wet with toxic photopolymer resin and are only partially cured — the post-processing steps are not optional finishing touches but essential manufacturing operations that determine the final mechanical, dimensional, and safety properties of the part.
      </p>

      <InfoBox title="Core Concepts at a Glance" items={[
        "All resin prints exit the printer coated in toxic uncured photopolymer — PPE (nitrile gloves, eye protection, ventilation) is mandatory at all stages until fully UV-cured",
        "Two-stage IPA wash: Stage 1 (dirty) removes bulk resin; Stage 2 (clean) provides final surface rinse — prevents contaminating clean IPA with high resin loads",
        "IPA must fully evaporate before UV curing — residual solvent causes oxygen inhibition, producing a permanently tacky surface layer",
        "UV post-curing at 405 nm completes photopolymerisation — time depends on resin type, colour, part size, and UV power; rotating turntable ensures even exposure",
        "Support removal can be done before (green state — easier) or after full cure — green-state removal keeps toxic resin risk; post-cure removal is safer but harder",
        "Surface finishing: wet sand P120→P2000, apply filler primer, paint with acrylics, seal with clear coat; resin coating (XTC-3D / clear resin) fills layer lines in one step",
        "UV-cured resin dust from sanding is a respiratory hazard — always use P100/FFP3 respirator; wet sanding eliminates airborne dust",
        "IPA and acetone are flammable — no ignition sources; store and dispose as chemical waste per local regulations",
        "Resin type determines post-processing: water-washable needs only water; high-temp and castable resins require extended UV cure schedules",
      ]}/>

      <h2 style={S.h2}>Complete Post-Processing Workflow</h2>
      <p style={S.p}>
        Every resin print requires the same fundamental sequence: remove from printer, drain, wash, dry, UV cure, remove supports, and finish. The order of support removal relative to UV curing is the main variable — both approaches are valid with different tradeoffs. Understanding the purpose and critical parameters of each step prevents the most common failures: tacky surfaces, warping, brittleness, and chemical exposure.
      </p>
      <DiagramWorkflow/>
      <Table2 rows={[
        ["Print removal","Wear nitrile gloves before touching build plate — uncured resin is a skin sensitiser\nTwist or flex the plate to release the print; use plastic scraper only (metal damages FEP)\nKeep print over the vat to catch drips; close vat lid to prevent UV contamination"],
        ["Drain time","Tilt print over vat at 45° for 5–15 min; allow resin to gravity-drain from overhangs and cavities\nShake gently to dislodge pockets; use syringe to clear enclosed hollow sections\nRecovered resin can be strained and returned to vat (filter through paint strainer)"],
        ["IPA concentration","91–99% IPA preferred; 70% contains water — slows washing and can cause white haze on surface\nAlternatives: Elegoo / Anycubic washing solutions, mono-propylene glycol (MPG) — less toxic\nMPG safer for ventilation-limited spaces but slower wash action than IPA"],
        ["Wash time","Too short: resin residue on surface → tacky after cure, poor finish\nToo long: can cause white powdering (IPA attacks partially-cured surface polymer)\nOptimum: 3–5 min agitation in dirty bath; 1–2 min in clean bath for most standard resins"],
        ["Drying before cure","Compressed air removes surface IPA rapidly; leave to air dry 5–15 min minimum\nIR lamp or warm air helps — never use open flame near IPA\nTest: wipe with clean tissue — no orange/resin-coloured residue before curing"],
        ["UV cure temperature","Warm resin cures faster — manufacturers often recommend 30–40°C during cure\nCold environments slow cure significantly; in winter, warm part in water bath first\nAvoid curing at >60°C — thermal stress can warp thin-walled parts"],
      ]}/>

      <h2 style={S.h2}>Washing — IPA Station Design &amp; Parameters</h2>
      <p style={S.p}>
        The washing stage removes uncured liquid resin from the print surface and internal channels using a solvent, typically isopropyl alcohol (IPA). Effective washing is critical: residual uncured resin prevents proper UV curing of the surface and leaves a permanently tacky, contaminated finish. The two-station approach is the professional standard, balancing effectiveness with solvent economy.
      </p>
      <DiagramWashStation/>
      <Table2 rows={[
        ["Two-stage washing rationale","Station 1 (dirty): removes ~85–90% of resin at low cost as IPA becomes contaminated quickly\nStation 2 (clean): fresh IPA completes the wash; contamination transferred to dirty bath is minimal\nExtends total IPA life 2–3× versus single-bath approach; produces cleaner results"],
        ["Agitation methods","Manual: swirl container by hand — effective for small prints\nMagnetic stirrer: consistent agitation, hands-free; suitable for production\nUltrasonic cleaner: best for fine detail and internal channels; 40 kHz frequency typical\nAvoid vigorous shaking with thin features — can snap delicate parts"],
        ["IPA saturation monitoring","Visual: IPA turns from clear → yellow → dark orange as resin load increases\nRefractometer: measures dissolved solids concentration more precisely\nReplace dirty bath when IPA is visibly dark orange or washing quality deteriorates\nSaturation threshold: approximately 10–15% dissolved resin by volume"],
        ["IPA regeneration","Leave contaminated IPA in clear container in direct sunlight 4–6 hours\nUV light cures dissolved resin — it settles as hard sludge at the bottom\nFilter clear supernatant through paint strainer — reusable for Stage 1 washing\nDispose of resin sludge as photopolymer chemical waste (not general waste)"],
        ["Water-washable resins","Wash with plain tap water in two stages — no IPA required\nWater wash is slower and requires more agitation for equivalent cleanliness\nDo NOT pour wash water down drain — resin is environmentally hazardous\nFilter and UV-cure sludge from water; dispose as chemical waste"],
        ["Acetone alternative","Acetone is a faster solvent than IPA but highly flammable (flashpoint −20°C)\nUse only in fully ventilated area with no ignition sources\nCan attack and soften some resins if left too long — test on scrap first\nNot recommended for production environments due to fire risk"],
      ]}/>

      <h2 style={S.h2}>UV Post-Curing</h2>
      <p style={S.p}>
        UV post-curing completes the photopolymerisation that was initiated during printing. Freshly printed and washed parts are only 40–60% polymerised — they are weaker, more flexible, and more chemically reactive than the same resin properly post-cured. The curing station uses 405 nm LED arrays (matching the photoinitiator absorption peak of most commercial resins) to drive conversion of remaining reactive groups.
      </p>
      <DiagramUVCuring/>
      <Table2 rows={[
        ["Degree of conversion","Freshly printed parts: ~40–60% monomer conversion\nAfter post-cure: >90% conversion; tensile strength increases 2–4×\nMeasured by FTIR spectroscopy — not practical for workshop use"],
        ["405 nm wavelength","Matches photoinitiator absorption peak (typically TPO or Irgacure 819)\n365 nm also works for some resins but less efficient for most MSLA resins\nSunlight contains sufficient 405 nm — outdoor curing is effective but slow and UV-variable"],
        ["Rotation and geometry","Rotate part 90° every 30–60 seconds or use motorised turntable\nInternal cavities may not cure without direct UV line-of-sight — fill with clear resin first\nThick opaque sections (>5 mm) may cure only on surface — use longer times or multiple orientations"],
        ["Over-curing effects","Extended UV exposure causes photooxidation — yellowing, embrittlement\nHigh-power UV stations can over-cure thin sections in 2–3 min\nUse timer; set power to 50% and double time rather than 100% power for delicate parts"],
        ["Water curing technique","Immersing in warm water (40–60°C) while curing improves surface cure quality\nWater provides thermal mass and slightly reduces oxygen inhibition at the surface\nRecommended for castable and dental resins requiring optimal surface quality"],
        ["Cure verification","Fingernail test: properly cured part cannot be dented with fingernail\nColour consistency: no lighter patches (under-cured) or darker spots (over-cured)\nDimensional stability: leave at room temperature 24 h — warping indicates insufficient cure"],
      ]}/>

      <h2 style={S.h2}>Support Removal</h2>
      <p style={S.p}>
        Supports are necessary for overhanging geometry during printing but must be removed cleanly after printing. Support removal strategy — whether to remove before or after UV curing, and which tools to use — significantly affects both part quality and operator safety. Green-state (before full cure) removal is easier mechanically but exposes the operator to toxic uncured resin throughout the process.
      </p>
      <DiagramSupportRemoval/>
      <Table2 rows={[
        ["Green state vs post-cure removal","Green state (before full UV cure): softer, more flexible — supports peel away easily\nReduces stress marks at contact points; reduces snapping of thin features\nRequires full PPE throughout (uncured resin exposure); complete post-cure after removal\nPost-cure removal: part is hard and stable; operator safety improved; needs more force"],
        ["Support settings in slicer","Touch point diameter: 0.4–0.8 mm — smaller = easier removal, higher failure risk\nSupport density: 50–75% — reduce for simple overhangs, increase for heavy sections\nSupport top/bottom: match to surface roughness tolerance\nTree supports vs column: tree supports generally easier to remove but less stable for heavy parts"],
        ["Scar treatment","Support contact scars: sand with P180–P400 to blend into surface\nFor high-detail areas: use dental burr in rotary tool to grind stump flush\nPrimer coat after sanding reveals remaining scars that need further work\nDeep pits: fill with UV-curable resin or modelling putty, cure, sand level"],
        ["Raft removal","Build raft: may require careful peeling starting from corner with palette knife\nRaft scar on base: sand P120→P400 if bottom surface quality is important\nAlternative: use perforation layer in slicer — raft separates cleanly at printed perforations"],
        ["Failed support repair","If part breaks during removal: bond with thin CA (super glue) — fill gap, cure fast\nFor larger breaks: resin bonding — clean surfaces with IPA, apply matching resin, UV cure\nColor-matched filler putty works for cosmetic repairs before priming"],
      ]}/>

      <h2 style={S.h2}>Surface Finishing</h2>
      <p style={S.p}>
        Resin prints exit the post-cure station with visible layer lines (typically 25–100 µm) and support scars. Surface finishing transforms these into smooth, paintable, and aesthetically finished parts. The level of finishing required depends on the end use: functional parts may need only light sanding, while display models and cosplay props often require extensive wet sanding, priming, painting, and clear coating.
      </p>
      <DiagramSurfaceFinishing/>
      <Table2 rows={[
        ["Wet vs dry sanding","Wet sanding: water as lubricant; prevents clogging; no airborne dust\nDry sanding: faster material removal; respirator essential; clogs quickly\nRecommendation: dry P120–P220 for bulk material removal; wet P320+ for final finish"],
        ["Progressive grit sequence","Each grit must remove all scratches from the previous step before moving on\nTypical sequence: P120 (support scars) → P220 → P400 → P800 → P1200 → P2000\nTest by backlighting at shallow angle — all previous scratches must be invisible\nSkipping grits wastes time — deep P120 scratches take very long to remove at P400"],
        ["Filler primer","Rattlecan filler primer (grey or white): fills scratches up to ~80 µm deep\nApply 2–3 thin coats, allow to dry 30–60 min, sand P400–P600 between coats\nHighlights remaining surface defects clearly — primer step reveals all imperfections\nChemical adhesion to resin is good; mechanical adhesion with light sanding is better"],
        ["Resin clear coat / XTC-3D","Two-component epoxy coating (XTC-3D, Smooth-On): brush on, self-levels\nFills layer lines in 1–2 coats; UV-curable clear resin achieves same result faster\nCure time: XTC-3D ~4 h at 20°C; UV resin: 2–5 min under UV\nTip: thin coats prevent drips; warm part slightly for better levelling"],
        ["Painting adhesion","Bare UV-cured resin: too smooth and non-porous for paint — primer essential\nAcrylic paints adhere well to primed resin; enamel paints also compatible\nAirbrushed lacquers: best for fine detail and gradients; requires good ventilation\nProtective topcoat: matte, satin, or gloss varnish; UV-protective versions prevent yellowing"],
        ["Polishing to gloss","After P2000 wet sand: polish with plastic polishing compound (Meguiar's PlastX)\nFinish with car detailing polish for mirror shine\nResin clear coat + polish achieves near-optical-quality transparency on clear/transparent resin\nSurface temperature during polishing: keep below 60°C — friction can soften resin"],
      ]}/>

      <h2 style={S.h2}>Resin Types &amp; Post-Processing Requirements</h2>
      <DiagramResinTypes/>
      <Table2 rows={[
        ["Standard resin","Most affordable; optimised for detail; brittle\nPost-process: standard IPA wash 3–5 min; UV cure 2–5 min; sands well\nLimit: brittle — snaps under impact; not suitable for functional mechanical parts"],
        ["ABS-like / tough resin","Flexural toughness 2–3× standard; less brittle; slight flexibility\nPost-process: standard wash; slightly longer cure for full toughness\nApplications: enclosures, brackets, snap-fit features, mechanical prototypes"],
        ["Flexible / TPU resin","Rubber-like; Shore hardness A 50–90; elongation to break 50–400%\nPost-process: longer IPA wash (resin clings); extended cure (7–10 min); vapour smooth\nChallenge: thin supports tear instead of clean release; increase contact point size"],
        ["High-temperature resin","HDT (heat deflection temperature) 180–300°C; used for mould inserts, brackets\nPost-process: long post-cure required (20–60 min) to achieve rated HDT\nChallenge: brittle until fully cured; supports harder to remove cleanly"],
        ["Castable / jewellery resin","Burns out cleanly in kiln investment casting (loss wax equivalent)\nPost-process: very clean wash critical (ash contamination); very long UV cure\nSurface: polish to mirror to improve cast detail; no priming/painting"],
        ["Water-washable resin","IPA-free: wash with tap water; much safer for home/education use\nPost-process: water wash 3–5 min with agitation; dry fully before UV cure\nLimitations: generally softer, higher shrinkage, reduced chemical resistance vs IPA-wash resins"],
        ["Dental / bio-medical resin","ISO 10993 certified biocompatible after proper post-cure; Class I or IIa\nPost-process: strict protocol — specific wash solutions, calibrated UV dose in medical-grade station\nCompliance: post-cure records must be retained; cannot substitute wash solutions arbitrarily"],
      ]}/>

      <h2 style={S.h2}>Safety, Hazards &amp; Disposal</h2>
      <DiagramSafetyMatrix/>
      <Table2 rows={[
        ["Skin sensitisation","Repeated skin contact with uncured resin causes irreversible allergic contact dermatitis\nOnce sensitised: any future contact — even very small amounts — triggers reaction\nPrevention: nitrile gloves (0.1 mm minimum) for ALL handling of uncured resin or wet IPA\nNote: latex gloves are NOT chemical-resistant; vinyl gloves are borderline adequate"],
        ["Respiratory hazards","Uncured resin vapour: VOCs, photoinitiators — use organic vapour respirator (OV cartridge)\nSanding dust (cured resin): potential carcinogen (fine particles, reactive surface groups)\nIPA vapour: PEL 400 ppm (OSHA); asphyxiant at high concentration\nWork near open window minimum; dedicated fan exhaust to outside strongly recommended"],
        ["Eye protection","Chemical splash from IPA / liquid resin: use splash goggles (not safety glasses alone)\nUV light: 405 nm is near-UV; avoid direct eye exposure from curing station\nLaser-cut resin flying chips during support removal: safety glasses always"],
        ["Fire and explosion","IPA flashpoint: 12°C — treat as highly flammable; no open flames, sparks, or hot surfaces\nIPA vapour/air mixtures are explosive between 2–12% concentration\nStore in metal safety cabinet; label all containers; max working quantity on bench: 1 L\nAcetone flashpoint: −20°C — even higher fire risk; specialist use only"],
        ["IPA disposal","Spent IPA with dissolved resin: cure resin in sludge by UV exposure outdoors\nFilter clear IPA through fine mesh — reusable for Stage 1 wash\nFinal disposal: IPA with cured resin sludge = chemical/hazardous waste\nNever pour uncured resin down drain — toxic to aquatic organisms (EC50 < 1 mg/L)"],
        ["Emergency procedures","Skin contact (uncured resin): wash immediately with soap and water for 15 min\nEye contact: flush with eyewash station 15 min; seek medical attention\nIngestion: seek emergency medical care; do not induce vomiting\nFire (IPA): CO₂ or dry chemical extinguisher; water may spread fire"],
        ["Regulatory compliance","EU: REACH regulation — resin SDSs must list SVHC above 0.1%\nUS: OSHA Hazard Communication (HazCom 2012); local VOC limits for IPA use\nElectronic waste: cured resin parts are not standard recyclable plastic — landfill or specialist\nUV-cured resin solid waste: in most jurisdictions, classified non-hazardous solid waste"],
      ]}/>

      <InfoBox title="Key Parameters &amp; Reference Values" items={[
        "IPA concentration: 91–99% recommended; 70% contains water — avoid for washing",
        "Wash time: 3–5 min (dirty bath) + 1–2 min (clean bath); over-washing causes white powdering",
        "UV cure wavelength: 405 nm standard (SLA/MSLA/DLP); 365 nm for some older formulations",
        "UV cure time: 2–5 min standard resin; 5–10 min ABS-like; 20–60 min high-temp / castable",
        "IPA saturation limit: replace when colour is dark orange; approx. 10–15% dissolved resin",
        "Support touch-point diameter: 0.4–0.8 mm in slicer; smaller = easier removal",
        "Sanding sequence: P120 → P220 → P400 → P800 → P1200 → P2000 (wet P400+)",
        "Filler primer: 2–3 coats; sand P400–P600 between coats; fills scratches up to ~80 µm",
        "Resin dust TLV: treat as nuisance dust minimum (5 mg/m³); use P100/FFP3 respirator when sanding",
        "IPA flashpoint: 12°C — store in ventilated cabinet, no ignition sources within 3 m",
      ]}/>
    </div>
  );
}